module.exports = __webpack_public_path__ + "static/img/meet-our-executive-team_3.06376c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/meet-our-executive-team_3.png
// module id = s7Rc
// module chunks = 0